window.MTGGoldfish = window.MTGGoldfish || {};
window.MTGGoldfish.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.MTGGoldfish.onDocumentReadyArray.push(function() { 
  //determines if the user has a set theme
  function detectColorScheme(){
      var theme="light";    //default to light

      //local storage is used to override OS theme settings
      var preference = Cookies.get('theme');
      if(preference) {
          if(preference === "dark" || preference === "light") {
              var theme = preference;
          }
      } else if(!window.matchMedia) {
          //matchMedia method not supported
          return false;
      } else if(window.matchMedia("(prefers-color-scheme: dark)").matches) {
          //OS theme setting detected as dark
          var theme = "dark";
      }

      //dark theme preferred, set document with a `data-theme` attribute
      if (theme=="dark") {
          $("#btn-toggle-dark").prop("checked", true);
          document.documentElement.setAttribute("data-theme", "dark");
      } else {
          document.documentElement.setAttribute("data-theme", "light");
      }
  }
  detectColorScheme();
  $(document).on('click', '#btn-toggle-dark', function (e) {
    console.log("toggle dark")
    if ($(e.target).prop("checked")) {
      document.documentElement.setAttribute("data-theme", "dark");
      Cookies.set('theme', 'dark', { expires: 3650, path: '/' }); // expire in 30 days
    } else {
      document.documentElement.setAttribute("data-theme", "light");
      Cookies.set('theme', 'light', { expires: 3650, path: '/' }); // expire in 30 days
    }
  });
});
